import type { PlanCapabilitiesSnapshot } from '../types/planCapabilities';

/** Kichik biznes: marketing / onlayn buyurtmalar menyuda ko‘rinadi (to‘lovsiz kontent bloklangan). */
export function marketingOnlineAddonNavVisible(planCaps: PlanCapabilitiesSnapshot | null | undefined): boolean {
  if (!planCaps?.features) return false;
  const f = planCaps.features;
  if (f.marketing_tools && f.online_orders) return true;
  const tk = String(planCaps.tariff_type_key ?? '').toLowerCase();
  if (tk !== 'businesssmall') return false;
  return (planCaps.marketing_online_addon_price_uzs ?? 0) > 0;
}

/** Sahifa ichida to‘lov modali — paket hali yoqilmagan va tarif kichik biznes. */
export function marketingOnlineAddonPaywallActive(planCaps: PlanCapabilitiesSnapshot | null | undefined): boolean {
  if (!marketingOnlineAddonNavVisible(planCaps)) return false;
  if (planCaps?.marketing_online_addon_active) return false;
  const f = planCaps?.features;
  if (!f) return false;
  return !f.marketing_tools || !f.online_orders;
}
